import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import TutorLoadingScreen from './TutorLoadingScreen'
import LessonScreenChat from './LessonScreenChat'
import MyCamera from './MyCamera'
import ParticipantCamera from './ParticipantCamera'
import LessonSlides from './LessonSlides'
import LessonHeader from './LessonHeader'
import JanusRoom from './JanusRoom'
import { useParams } from 'react-router-dom'

const TutorLessonScreen = () => {
  const { lessonId } = useParams()
  const localVideoRef = useRef<HTMLVideoElement | null>(null)
  const remoteVideoRef = useRef<HTMLVideoElement | null>(null)
  const webRtcMounted = useSelector((state: RootReducer) => state.tutorChannelReducer.webRtcMounted)

  useEffect(() => {
    if (!webRtcMounted) {
      if (remoteVideoRef.current) {
        remoteVideoRef.current.srcObject = null
      }
    }
  }, [webRtcMounted])

  return (
    <div className="font-sans max-h-screen">
      <JanusRoom roomId={parseInt(lessonId ?? '0')} localVideoRef={localVideoRef} remoteVideoRef={remoteVideoRef} />
      <div className="bg-lightGray">
        <div className="relative bg-lightGray min-h-screen flex flex-col max-w-[200vh] mx-auto">
          <LessonHeader />
          <div className="h-2" />
          <div className="flex flex-1">
            <div className="relative flex-1 flex justify-between">
              <div className="w-5" />
              <div className="flex-1 justify-center flex mt-1">
                <LessonSlides user="tutor" />
              </div>
              <div className="w-5" />
              <div className="flex items-end justify-between flex-col w-[35%] mr-4">
                <ParticipantCamera remoteVideoRef={remoteVideoRef} />
                <div className="h-4" />
                <MyCamera localVideoRef={localVideoRef} />
                <div className="h-7" />
              </div>
            </div>
            <LessonScreenChat user="tutor" />
            <div className="w-2" />
          </div>
          <div className="h-2" />
        </div>
      </div>
      <TutorLoadingScreen />
    </div>
  )
}

export default TutorLessonScreen
